import React, { Component, useEffect } from "react";
import { Modal } from "react-bootstrap";
import $ from "jquery";
import RegistrationsService from "../../RegistrationsService";
import registrationsAction from "../../../../store/registrations/action";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import StepOne from "../RegDetails/Wizard/stepOne";
import StepThree from "../RegDetails/Wizard/stepThree";
import StepTwo from "../RegDetails/Wizard/stepTwo";
import "../RegDetails/Wizard/steps-prog.css";
import CloseRegistrationWizardModal from "./CloseRegistrationWizardModal";
import { Formik, Form } from "formik";
import { initForm, makeuid } from "../../Helpers/QuestionsFormUtils";
import SucessfulPayment from "../../../Payments/SucessfulPayment";
import AdminDeferredPaymentSuccess from "../../../Payments/AdminDeferredPaymentSuccess";
import PaymentDeferralBadge from "../RegDetails/Wizard/PaymentDeferralBadge";
import Portal from "@material-ui/core/Portal";
import { toast } from "react-toastify";
import {
  RegistrationTableTypes,
  RegistrationStatuses,
  RegisWizardCloseActions,
  PaymentStatuses,
  SessionStaus,
  RegisWizardSteps,
} from "../../Helpers/LookUpValues";
import _ from "lodash";
import PaymentService from "../../../Payments/PaymentService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { debounce } from "throttle-debounce";

// How many members the picker requests per search.
const MEMBER_SEARCH_PAGE_SIZE = 10;

const initialState = {
  showConfirmCloseRegModal: false,
  currentStep: 0, // Default is Step 0
  isExecutePaymentFlow: false,
  isFinishedPaymentFlow: false,
  isFailedPaymentFlow: false,
  anyRequiredFeeQuestions: false,
  anyFeeQuestions: false,
  steps: [
    {
      key: RegisWizardSteps.FirstStep,
      label: "Details",
      isDone: false,
    },
    {
      key: RegisWizardSteps.SecondStep,
      label: "Questions",
      isDone: false,
    },
    {
      key: RegisWizardSteps.ThirdStep,
      label: "Payment",
      isDone: false,
    },
    {
      key: RegisWizardSteps.FourthStep,
      label: "Success",
      isDone: false,
    },
  ],
  paymentSteps: [
    {
      key: RegisWizardSteps.ThirdStep,
      label: "Payment",
      isDone: false,
    },
    {
      key: RegisWizardSteps.FourthStep,
      label: "Success",
      isDone: false,
    },
  ],
  successStep: {
    key: RegisWizardSteps.FourthStep,
    label: "Success",
    isDone: false,
  },

  activeStep: {
    key: RegisWizardSteps.FirstStep,
    label: "Registration Details",
    isDone: false,
  },
  initialValues: [],
  validationSchema: {},
  // Set once a target member is picked and we know what they already have on this class.
  // targetRegistrationBlocked holds { statusId, name } when their registration is settled and
  // the submit will be refused; targetAdoptedStatusId is set when it is unfinished and the
  // wizard has loaded their existing answers instead of a blank form.
  targetRegistrationBlocked: null,
  targetAdoptedStatusId: null,
  targetAdoptedStatusName: null,
  // True while the lookup below is in flight. The round trip takes several seconds -- it
  // resolves the caller's permissions before reading the registration -- and until it
  // returns the wizard cannot tell an already-registered member from a new one, so the
  // step buttons stay shut rather than letting the form be filled in on a stale screen.
  targetCheckInFlight: false,
  // Which registration the question set on screen was loaded from; null means the blank set
  // for this class. Compared before any reload so an unchanged source leaves the form alone.
  loadedForRegistrationId: null,
  pauseRegistration: false,
  wizardBtnCloseAction: 0,
  prevValues: [],
  rawQuestionData: [],
  questionsFee: 0,
  // Admin on-behalf state
  selectedTargetMemberId: null,
  selectedTargetMemberName: "",
  memberOptions: [],
  // Whether a member search is currently running. The endpoint reports no match total, so
  // there is nothing to say about results beyond the page size.
  memberSearchInFlight: false,
  searchTerm: "",
};
class RegisterMemberModal extends Component {
  constructor(props) {
    super(props);
    // Set the initial input values
    // Bind new functions for next and previous
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
    this.portalRef = React.createRef();
    this.state = {
      ...initialState,
    };

    // Initialize debounced search (500ms delay)
    this.autocompleteSearchDebounced = debounce(500, this.autocompleteSearch);

    // Bind the submission to handleChange()
    this.handleChange = this.handleChange.bind(this);
    this.handleTargetMemberSelection = this.handleTargetMemberSelection.bind(this);
    this.confirmCancelRegModal = () => {
      this.confirmed = async (callSubmitForm, closeBtnAct, setFormErrors) => {
        this.setState(
          { pauseRegistration: true, wizardBtnCloseAction: closeBtnAct },
          () => {
            //setFormErrors({});
            callSubmitForm();
          }
        );
      };

      return this;
    };
  }

  // Helper method to calculate fee based on current form values
  calculateQuestionsFee(values) {
    if (!values || !this.state.rawQuestionData) return 0;

    const allFeeAssocQues = this.state.rawQuestionData
      .filter((f) => f.isFeeAssociated)
      .map((m) => m.uid);

    const feeAnswersKeys = Object.keys(values).filter(
      (f) => allFeeAssocQues.includes(f) && values[f]
    );

    const totalFee = this.state.rawQuestionData
      .filter((f) => feeAnswersKeys.includes(f.uid))
      .reduce((accumulator, object) => {
        return accumulator + (object.fee || 0);
      }, 0);

    return totalFee;
  }

  // Helper method to check if any fee questions are answered
  checkAnyFeeQuestionAnswered(values) {
    if (!values || !this.state.rawQuestionData) return false;

    const allFeeAssocQues = this.state.rawQuestionData
      .filter((f) => f.isFeeAssociated)
      .map((m) => m.uid);

    return Object.keys(values)
      .filter((f) => allFeeAssocQues.includes(f))
      .some((key) => values[key]);
  }

  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  // Member search handler with debouncing
  memberSearchHandler = (searchTerm) => {
    this.setState({ searchTerm: searchTerm }, () => {
      this.autocompleteSearchDebounced();
    });
  }

  // Debounced autocomplete search
  autocompleteSearch = () => {
    this.loadMemberData();
  }

  // Load member data from API
  loadMemberData = async () => {
    const { searchTerm } = this.state;
    if (!searchTerm || searchTerm.length < 2) return;

    // The first search after a restart rebuilds the member cache inside the request and can
    // take ten seconds or more. Without this flag the box simply sits empty for that whole
    // time, which is indistinguishable from "no such member" -- the reason the search was
    // reported as broken when it was working.
    this.setState({ memberSearchInFlight: true });
    try {
      let data = await RegistrationsService.LoadMembers(searchTerm, 0, MEMBER_SEARCH_PAGE_SIZE);
      if (!_.isEmpty(data) && data.statusCode == 200) {
        this.setState({
          memberOptions: data.result || [],
        });
      }
    } finally {
      this.setState({ memberSearchInFlight: false });
    }
  }

  // The pair of statuses an administrator may register over. Mirrors
  // AdminAdoptableStatuses in RegistrationsService -- both are "this row exists but has
  // not been settled". Change one and change the other.
  static ADOPTABLE_STATUSES = [
    RegistrationStatuses.InProgress,
    RegistrationStatuses.PendingRegistration,
  ];

  // Pushes a question payload into component state, redux and the Formik form. Shared by
  // onShow and by target-member selection, which has to be able to swap the whole question
  // set once it knows whose registration it is looking at.
  applyQuestions = (questionsResponse) => {
    const withUids = questionsResponse.map((question) => ({
      ...question,
      uid: makeuid(5),
    }));
    this.setState({
      rawQuestionData: withUids,
      anyFeeQuestions: withUids.some((q) => q.isFeeAssociated),
      anyRequiredFeeQuestions: withUids.some((q) => q.isFeeAssociated && q.isRequired),
    });
    const questionsJson = withUids.reduce((obj, cur) => ({ ...obj, [cur.uid]: cur }), {});
    this.props.setRegistrationQuestions(questionsJson);
    // Formik has enableReinitialize, so replacing initialValues repopulates the fields.
    const { _formData, _validationSchema } = initForm(questionsJson);
    this.setState({
      initialValues: _formData,
      validationSchema: _validationSchema,
      prevValues: _formData,
    });
  };

  // Once a target member is known, find out what they already have on this class. Until this
  // runs the wizard knows only about the administrator, so a member who is already registered
  // looks identical to one who is not.
  checkTargetMemberRegistration = async (memberId) => {
    const { occasionId } = this.props;
    this.setState({ targetRegistrationBlocked: null, targetAdoptedStatusId: null, targetAdoptedStatusName: null });
    if (!memberId || !occasionId) return;

    // This lookup resolves the caller's permissions before reading the registration and takes
    // several seconds -- measured between 7 and 36. Change the member twice inside that window
    // and the replies can land out of order, leaving the wizard describing someone the
    // administrator is no longer registering. Only the newest request may write to state.
    const seq = (this.targetCheckSeq || 0) + 1;
    this.targetCheckSeq = seq;

    let details = null;
    this.setState({ targetCheckInFlight: true });
    try {
      details = await RegistrationsService.GetOpenedEventDetails(occasionId, memberId);
    } catch (e) {
      return; // leave the wizard as it was; the server still refuses on submit
    } finally {
      if (seq === this.targetCheckSeq) {
        this.setState({ targetCheckInFlight: false });
      }
    }
    if (seq !== this.targetCheckSeq) return; // superseded by a later selection

    // No live registration: the blank form loaded at open time is correct for them.
    if (!details || !details.regisExists || !details.registrationId) {
      this.setState({ targetRegistrationBlocked: null, targetAdoptedStatusId: null, targetAdoptedStatusName: null });
      await this.reloadQuestions(null);
      return;
    }

    if (RegisterMemberModal.ADOPTABLE_STATUSES.includes(details.regisStatusId)) {
      // An unfinished registration. Show what they actually answered rather than a blank
      // form: the admin is continuing their registration, not starting one, and submitting
      // blanks over it would leave two sets of answers with nothing to say which is current.
      this.setState({ targetAdoptedStatusId: details.regisStatusId, targetAdoptedStatusName: details.regisStatus });
      await this.reloadQuestions(details.registrationId);
      return;
    }

    // Anything else is settled. The server refuses this with a 409; say so here so the
    // administrator finds out before filling the form in, not after.
    this.setState({
      targetRegistrationBlocked: {
        statusId: details.regisStatusId,
        statusName: details.regisStatus,
      },
    });
    await this.reloadQuestions(null);
  };

  // Re-fetches the question set, with the member's answers when there is a registration to
  // read them from. Also used to clear a previous member's answers back to blanks.
  //
  // Does nothing when the set on screen already came from the same place. That guard is
  // load-bearing, not an optimisation: applying a payload regenerates every field uid and
  // replaces initialValues, and Formik runs with enableReinitialize, so a needless reload
  // silently empties whatever the administrator has typed. The picker sits on the questions
  // step as well as the details step, so "type the answers, then pick the member" is an
  // ordinary thing to do -- and before this guard it threw the answers away with no warning.
  reloadQuestions = async (registrationId) => {
    const { occasionId } = this.props;
    const wanted = registrationId || null;
    if (wanted === this.state.loadedForRegistrationId) {
      return;
    }
    try {
      const data = wanted
        ? await RegistrationsService.GetOccasionRegQuestionsWithAnswers(occasionId, wanted)
        : await RegistrationsService.GetOccasionRegistrationQuestions(occasionId);
      if (data && data.statusCode == 200) {
        this.applyQuestions(data.result);
        this.setState({ loadedForRegistrationId: wanted });
      }
    } catch (e) {
      // keep whatever is on screen
    }
  };

  handleTargetMemberSelection(e, value) {
    const { isRegisteringForOthers } = this.props;

    if (value) {
      // Admin selected a target member - switch to on-behalf registration flow
      this.setState({
        selectedTargetMemberId: value.id,
        selectedTargetMemberName: `${value.name || `${value.firstName || ""} ${value.lastName || ""}`}`.trim(),
      }, () => {
        // Recalculate steps if we're on step 2 and there are fee questions
        if (isRegisteringForOthers && this.state.anyFeeQuestions && this.state.currentStep === 1) {
          this.adjustStepsForAdminRegistration();
        }
        // Find out what this member already has on the class. Deliberately after the state
        // is set, so the warning can name them.
        this.checkTargetMemberRegistration(value.id);
      });
    } else {
      // Admin deselected target member - switch back to self-registration flow
      this.setState({
        selectedTargetMemberId: null,
        selectedTargetMemberName: "",
        targetRegistrationBlocked: null,
        targetAdoptedStatusId: null,
        targetAdoptedStatusName: null,
        targetCheckInFlight: false,
      }, () => {
        // Recalculate steps if we're on step 2 and there are fee questions
        if (isRegisteringForOthers && this.state.anyFeeQuestions && this.state.currentStep === 1) {
          this.adjustStepsForSelfRegistration();
        }
        // Back to registering themselves: drop whatever member's answers were on screen.
        this.reloadQuestions(null);
      });
    }
  }

  // Helper method to adjust steps for admin-on-behalf registration
  adjustStepsForAdminRegistration() {
    const { steps } = this.state;
    const hasPaymentStep = steps.findIndex((n) => n.key === RegisWizardSteps.ThirdStep) !== -1;
    const hasSuccessStep = steps.findIndex((n) => n.key === RegisWizardSteps.FourthStep) !== -1;

    // Remove both payment and success steps for admin on-behalf registration
    // Payment is deferred to target member, so there's no payment flow or success step
    if (hasPaymentStep || hasSuccessStep) {
      const filteredSteps = steps.filter(
        (s) => s.key !== RegisWizardSteps.ThirdStep && s.key !== RegisWizardSteps.FourthStep
      );
      this.setState({
        steps: filteredSteps,
        isExecutePaymentFlow: false,
      });
    }
  }

  // Helper method to adjust steps for self-registration
  adjustStepsForSelfRegistration() {
    const { steps, paymentSteps, isFinishedPaymentFlow } = this.state;
    const hasPaymentStep = steps.findIndex((n) => n.key === RegisWizardSteps.ThirdStep) !== -1;

    // Add payment steps back if fee questions are answered and payment isn't finished
    if (!hasPaymentStep && !isFinishedPaymentFlow) {
      const filteredSteps = steps.filter((s) => s.key !== RegisWizardSteps.FourthStep);
      this.setState({
        steps: [...filteredSteps, ...paymentSteps],
        isExecutePaymentFlow: true,
      });
    }
  }

  // Helper method to update payment step visibility based on current state
  updatePaymentStepVisibility(anyFeeQuestionAnswered) {
    const {
      isRegisteringForOthers,
      registrationRow,
      regisExists,
    } = this.props;
    const {
      steps,
      isFinishedPaymentFlow,
      successStep,
      paymentSteps,
      isExecutePaymentFlow,
    } = this.state;

    const isPendingPayment = registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember;
    const hasPaymentSteps = steps.findIndex((n) => n.key === RegisWizardSteps.ThirdStep) !== -1 ||
                            steps.findIndex((n) => n.key === RegisWizardSteps.FourthStep) !== -1;

    if (
      !registrationRow ||
      registrationRow.regisStatusId === 0 ||
      registrationRow.regisStatusId === RegistrationStatuses.InProgress ||
      registrationRow.regisStatusId === RegistrationStatuses.PendingRegistration ||
      isPendingPayment
    ) {
      if (anyFeeQuestionAnswered || isPendingPayment) {
        // Only skip payment if admin has ACTUALLY selected a target member
        const isAdminRegisteringForOther =
          isRegisteringForOthers &&
          this.state.selectedTargetMemberId &&
          anyFeeQuestionAnswered;

        if (!hasPaymentSteps) {
          // Payment steps don't exist, need to add them
          if (isAdminRegisteringForOther) {
            // Admin registering for another member - no payment or success steps
            // Payment is deferred, just keep Steps 1 and 2
            this.setState({
              isExecutePaymentFlow: false,
            });
          } else if (isFinishedPaymentFlow) {
            // Normal self-registration with finished payment - show success step only
            this.setState({
              steps: [...steps, successStep],
            });
          } else {
            // Show payment step for normal flow or admin self-registration
            this.setState({
              steps: [...steps, ...paymentSteps],
              isExecutePaymentFlow: true,
            });
          }
        } else {
          // Payment steps exist, just ensure correct flow state
          if (isAdminRegisteringForOther && isExecutePaymentFlow) {
            // Admin on-behalf registration - remove both payment and success steps
            var filteredSteps = this.state.steps.filter(
              (s) =>
                s.key !== RegisWizardSteps.ThirdStep &&
                s.key !== RegisWizardSteps.FourthStep
            );
            this.setState({
              steps: filteredSteps,
              isExecutePaymentFlow: false,
            });
          } else if (!isAdminRegisteringForOther && !isExecutePaymentFlow) {
            // Need to switch from no-payment to payment
            this.setState({
              isExecutePaymentFlow: true,
            });
          }
        }
      } else {
        // No fee questions answered - remove payment steps if they exist
        if (hasPaymentSteps || isExecutePaymentFlow) {
          var filteredSteps = this.state.steps.filter(
            (s) =>
              s.key !== RegisWizardSteps.ThirdStep &&
              s.key !== RegisWizardSteps.FourthStep
          );
          this.setState({
            steps: filteredSteps,
            isExecutePaymentFlow: false,
          });
        }
      }
    }
  }
  // Test current step with ternary
  // _next and _previous functions will be called on button click
  _next() {
    ///console.log("submitForm", this.submitForm);
    //this.submitForm.click();
    let { currentStep, steps, activeStep } = this.state;
    const { isRegisteringForOthers } = this.props;
    const index = steps.findIndex((x) => x.key === activeStep.key);
    let maxLength = steps.length - 1;

    // Check if we're moving from Step 1 to Step 2 and need to recalculate steps
    const isMovingFromStep1ToStep2 =
      activeStep.key === RegisWizardSteps.FirstStep &&
      index + 1 < steps.length &&
      steps[index + 1].key === RegisWizardSteps.SecondStep;

    if (isMovingFromStep1ToStep2 && isRegisteringForOthers && this.state.anyFeeQuestions) {
      // Recalculate steps based on whether a target member is selected
      if (this.state.selectedTargetMemberId) {
        // Admin selected a target member - remove payment/success steps
        this.adjustStepsForAdminRegistration();
      } else {
        // Admin deselected or never selected target - ensure payment steps are present
        this.adjustStepsForSelfRegistration();
      }

      // After adjusting steps, we need to use setTimeout to ensure state update completes
      // before proceeding with navigation
      setTimeout(() => {
        this._proceedToNextStep();
      }, 0);
      return;
    }

    // Normal navigation without step adjustment
    this._proceedToNextStep();
  }

  _proceedToNextStep() {
    let { currentStep, steps, activeStep } = this.state;
    const index = steps.findIndex((x) => x.key === activeStep.key);
    let maxLength = steps.length - 1;

    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= maxLength ? maxLength : currentStep + 1;
    this.setState({
      currentStep: currentStep,
    });
    let item = { ...steps[index] };

    item.isDone = true;
    steps[index] = item;

    this.setState({ activeStep: steps[index + 1] });

    this.setState({ steps });
  }

  _prev() {
    let { currentStep, steps, activeStep } = this.state;
    // If the current step is 2 or 3, then subtract one on "previous" button click
    let firstStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FirstStep
    );
    if (currentStep <= firstStepIdx) {
      return;
    }
    currentStep = currentStep <= firstStepIdx ? firstStepIdx : currentStep - 1;
    this.setState({
      currentStep: currentStep,
    });
    const index = steps.findIndex((x) => x.key === activeStep.key);

    let item = { ...steps[currentStep] };

    item.isDone = false;
    steps[currentStep] = item;

    this.setState({ activeStep: steps[index - 1] });

    this.setState({ steps });
  }
  showPaymentSuccess = () => {
    let { steps } = this.state;

    let modifiedSteps = steps
      .map((m) => {
        if (m.key != RegisWizardSteps.FourthStep) return { ...m, isDone: true };
        else {
          return { ...m, isDone: false };
        }
      })
      .filter((s) => s.key !== RegisWizardSteps.ThirdStep); // exclude Payment Step
    let fourthStepIdx = modifiedSteps.findIndex(
      (f) => f.key == RegisWizardSteps.FourthStep
    );
    if (fourthStepIdx != -1) {
      this.setState({ steps: modifiedSteps }, () => {
        this.setState({ activeStep: modifiedSteps[fourthStepIdx] });
        this.setState({ currentStep: fourthStepIdx });
      });
    }
  };
  // The "next" and "previous" button functions
  get previousButton() {
    let { currentStep, steps } = this.state;
    let firstStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FirstStep
    );
    // If the current step is not 0, then render the "previous" button
    if (currentStep !== firstStepIdx) {
      return (
        <button
          className="btn btn-info mr-1"
          type="button"
          onClick={this._prev}
        >
          <i class="fa fa-chevron-circle-left" aria-hidden="true">
            Previous
          </i>
        </button>
      );
    }
    return null;
  }

  get nextButton() {
    let { currentStep, steps } = this.state;
    // If the current step is not last step, then render the "next" button
    let lastStepIdx = steps.length - 1;
    if (currentStep < lastStepIdx) {
      // Left visible but inert while the chosen member already holds a settled registration.
      // Removing it would read as the wizard breaking; disabled with the reason stated above
      // it says whose state is in the way.
      const blocked = !!this.state.targetRegistrationBlocked || this.state.targetCheckInFlight;
      return (
        <button className="btn btn-success" type="button" onClick={this._next} disabled={blocked}
          title={blocked
            ? (this.state.targetCheckInFlight
              ? "Checking this member's registrations..."
              : "This member already has a registration for this class.")
            : undefined}>
          <i class="fa fa-arrow-circle-right" aria-hidden="true">
            Next
          </i>
        </button>
      );
    }
    // ...else render nothing
    return null;
  }

  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };

  handleClose = () => {
    const { registrationRow, regisExists } = this.props;
    const { steps } = this.state;
    let secondStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.SecondStep
    );
    const isDisabled =
      registrationRow &&
      registrationRow.regisStatusId != RegistrationStatuses.InProgress &&
      registrationRow.regisStatusId !=
      RegistrationStatuses.PendingRegistration &&
      regisExists;
    // Nothing to lose means nothing to confirm. Plenty of classes have no questions
    // attached -- about a third of them -- and on those the questions step holds only the
    // member picker, so the prompt announced that "anything you have entered will not be
    // saved" when nothing had been entered, and offered to save an empty draft. That draft
    // was real: an InProgress registration with no answers, which then sat in the member's
    // My Registrations for no reason. A confirmation that is wrong on a third of classes is
    // how people learn to click past the ones that matter.
    //
    // Only the empty-question-set case is excluded. Prompting solely when the form has
    // actually changed would be better still, and would also cover opening this step and
    // closing it untouched, but it needs the live Formik values in here and a dirty check
    // that errs the wrong way discards real answers silently. Separate ticket.
    const hasQuestions = (this.state.rawQuestionData || []).length > 0;
    if (
      (registrationRow.regisStatusId == RegistrationStatuses.InProgress ||
        registrationRow.regisStatusId ==
        RegistrationStatuses.PendingRegistration ||
        _.isEmpty(registrationRow.regisStatusId)) &&
      !isDisabled &&
      hasQuestions &&
      this.state.currentStep == secondStepIdx
    ) {
      this.toggleShowConfirmCloseRegModal();
    } else {
      this.justCloseRegModal();
    }
  };

  toggleShowConfirmCloseRegModal = () => {
    this.setState({
      showConfirmCloseRegModal: !this.state.showConfirmCloseRegModal,
    });
  };
  onShow = async () => {
    const { props } = this;
    const {
      occasionId,
      registrationId,
      paymentStatusId,
      showSuccessPage,
      registrationRow,
      regisExists,
      isRegisteringForOthers,
      targetMemberId,
    } = props;
    //debugger;
    if (occasionId) {
      this.showSpinner();
      this.setState(initialState);
      let relatedFunction;

      if (
        this.props.regTableType !== RegistrationTableTypes.MyRegistrations &&
        !registrationId
      ) {
        // No Registration-Id means no Questions have been Answered yet
        ///// When Opened from Opened Registrations Tab....
        relatedFunction = RegistrationsService.GetOccasionRegistrationQuestions;
        ///Right now only event id avaialble, Registration Id can be Generated only after
        ///Registration Wizard's Step 2......
      } else {
        //It would be the edit mode of MyRegistration's view mode..
        relatedFunction =
          RegistrationsService.GetOccasionRegQuestionsWithAnswers;
      }
      await relatedFunction(occasionId, registrationId)
        .then(async (data) => {
          if (data.statusCode == 200) {
            let questionsResponse = data.result;
            const anyFeeQuestions = questionsResponse.some((question) => {
              return question.isFeeAssociated;
            });
            const anyRequiredFeeQuestions = questionsResponse.some(
              (question) => {
                return question.isFeeAssociated && question.isRequired;
              }
            );
            this.setState({
              anyRequiredFeeQuestions: anyRequiredFeeQuestions,
              anyFeeQuestions: anyFeeQuestions,
            });
            console.log("paymentStatusId", paymentStatusId);
            if (paymentStatusId == PaymentStatuses.Success) {
              this.setState({
                isFinishedPaymentFlow: true,
              });
              var steps = this.state.steps.filter(
                (s) => s.key !== RegisWizardSteps.ThirdStep //Removed Payment Step
              );
              this.setState({
                steps: steps,
              });
            }
            if (
              anyFeeQuestions &&
              anyRequiredFeeQuestions &&
              registrationRow &&
              registrationRow.regisStatusId !=
              RegistrationStatuses.InProgress &&
              registrationRow.regisStatusId !=
              RegistrationStatuses.PendingRegistration &&
              regisExists
            ) {
              if (registrationId && paymentStatusId == PaymentStatuses.UnPaid) {
                //Check from Remote stripe API that, is the Payment really happended? or Our App is just Unsynced
                var response = await PaymentService.GetStripeSession(
                  registrationId
                );
                console.log("checking online status of payment");

                if (!_.isEmpty(response)) {
                  if (response.sessionStatus == SessionStaus.complete) {
                    this.setState({
                      isFinishedPaymentFlow: true,
                    });
                    this.showPaymentSuccess();
                    //Manually fullfill the Order
                    var response = await PaymentService.HandleCheckoutSuccess(
                      registrationId,
                      occasionId
                    );
                  }
                }
              } else if (
                registrationId &&
                paymentStatusId == PaymentStatuses.Success
              ) {
                this.setState({
                  isFinishedPaymentFlow: true,
                });
              }
              if (paymentStatusId == PaymentStatuses.Failed) {
                this.setState({
                  isFailedPaymentFlow: true,
                });
              }
              // if (
              //    paymentStatusId == 0 ||
              //    (paymentStatusId == null && registrationRow.IsSessionExists)
              //  ) {
              //  }
            }

            //this.setState({ questionsFee: totalFee }); //Amount for total Fee, used in Step3 Payment

            questionsResponse = questionsResponse.map((question) => ({
              ...question,
              uid: makeuid(5),
            }));
            this.setState({
              rawQuestionData: questionsResponse,
              loadedForRegistrationId: registrationId || null,
            });

            const questionsJson = questionsResponse.reduce(
              (obj, cur) => ({
                ...obj,
                [cur.uid]: cur,
              }),
              {}
            );
            this.props.setRegistrationQuestions(questionsJson);
            if (showSuccessPage) {
              this.showPaymentSuccess();
            }
            this.hideSpinner();
          } else {
            this.hideSpinner();
          }
        })
        .catch((error) => {
          this.hideSpinner();
        });
    }

    // prime selected target if provided via props
    if (isRegisteringForOthers && targetMemberId) {
      this.setState({ selectedTargetMemberId: targetMemberId });
    }

    let { selectedOpenRegQuestions } = this.props.registrationsState;
    let { _formData, _validationSchema } = initForm(selectedOpenRegQuestions);
    this.setState({ initialValues: _formData });
    this.setState({ validationSchema: _validationSchema });
    this.setState({ prevValues: _formData }, () => {
      // After initializing form, check if we need to show payment step
      // This handles the case when modal opens with existing answers
      const anyFeeQuestionAnswered = this.checkAnyFeeQuestionAnswered(_formData);
      this.updatePaymentStepVisibility(anyFeeQuestionAnswered);
    });
  };
  onSubmit = async (fields, helpers, details) => {
    console.log("details", details);
    let mySelf = this;
    const { currentStep, isExecutePaymentFlow, steps } = this.state;

    let secondStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.SecondStep
    );
    const {
      selectedOpenRegQuestions,
      //paymentStatus,
    } = this.props.registrationsState;
    let questionsWithAnswers = Object.entries(selectedOpenRegQuestions).map(
      (f) => ({
        value: fields[f[1].uid],
        id: f[1].id,
        questionType: f[1].questionType,
        isFeeAssociated: f[1].isFeeAssociated,
        fee: f[1].fee,
        answerMappingId: f[1].answerMappingId,
      })
    );

    let formData = {
      Questions: questionsWithAnswers,
      ChildTemplateId: this.props.occasionId,
      Registration_id: this.props.registrationId || 0,
      //PaymentStatus: paymentStatus,
      CloseBtnAction: this.state.wizardBtnCloseAction,
      CurrentStep: this.state.currentStep,
      TargetMemberId: (this.props.isRegisteringForOthers ? (this.state.selectedTargetMemberId || this.props.targetMemberId) : null) || null,
    };
    if (
      currentStep < 3 &&
      isExecutePaymentFlow &&
      !this.state.pauseRegistration
    ) {
      if (currentStep == secondStepIdx) {
        // Going forward from (Step(2)) of Answering Questions to Next Payment Screen(Step3)
        formData.CloseBtnAction = RegisWizardCloseActions.JustSaveAnswers; //Just Save the Question's Answers
        if (this.props.registrationId) {
          this._next();
        } else {
          await RegistrationsService.AddUpdateQuestionAnswers(formData).then(
            async (data) => {
              if (data && data.status && data.status == "Success") {
                await mySelf.props
                  .updateRegistrationId(data.registrationId)
                  .then(() => {
                    this._next();
                  });
              }
            }
          );
        }
      } else {
        this._next();
      }
    } else {
      //NO Payment Flow
      //It could be
      //1)Save&Close OR
      //2)Last Step Submit Action
      //3)PayNow Button
      //console.log("In onSubmit Method", JSON.stringify(formData));
      if (this.state.pauseRegistration) {
        formData.CloseBtnAction = this.state.wizardBtnCloseAction; //Should be Save&Close action
      } else {
        formData.CloseBtnAction = RegisWizardCloseActions.Submit; //Submit the Registration
      }
      await RegistrationsService.AddUpdateQuestionAnswers(formData).then(
        (data) => {
          if (data && data.status && data.status == "Success") {
            toast.success(data.message);
            if (this.state.pauseRegistration) {
              this.toggleShowConfirmCloseRegModal();
            }
            this.props.onClose();
          } else {
            // No toast here. RegistrationsService.AddUpdateQuestionAnswers only ever returns
            // null after it has already shown the reason -- the server's own message for a
            // refusal, or the interceptor's text for a network failure. Adding a generic one
            // put a second, vaguer toast on top of the specific one, so a member told exactly
            // why their registration was refused was also told "Something went wrong."
            //
            // The modal deliberately stays open: nothing was saved, and the reason on screen
            // is only useful next to the form it refers to.
          }
        }
      );

      ///this.props.reloadQuestions();
    }
  };
  justCloseRegModal = () => {
    this.props.onClose(); //No API hit
  };
  // validate = (values, props) => {
  //   let errors = { questions: [] };
  //   const { currentStep } = this.state;
  //   if (currentStep == 2) {
  //     const { questions } = values;
  //     questions.forEach((question, idx, allQuestions) => {
  //       if (
  //         (question.isRequired &&
  //           question.questionType == QuestionTypes.Text &&
  //           typeof question[question.uid] == "undefined") ||
  //         question[question.uid] == ""
  //       ) {
  //         errors.questions.push({ [question.uid]: "Required" });
  //       }
  //     });
  //   } else {
  //     errors = {};
  //   }
  //   console.log("In validate Method", JSON.stringify(errors));
  //   debugger;
  //   return errors;
  // };
  setPrevValues = (values) => {
    this.setState({ prevValues: values });
  };
  render() {
    const { selectedOpenRegRow, selectedOpenRegQuestions } =
      this.props.registrationsState || {};
    const { prevValues, steps, currentStep } = this.state;
    const {
      registrationRow,
      occasionId,
      registrationId,
      regisExists,
      paymentStatusId,
      isRegisteringForOthers,
    } = this.props;
    let fourthStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FourthStep
    );
    let thirdStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.ThirdStep
    );
    let firstStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FirstStep
    );
    let secondStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.SecondStep
    );
    const isPendingPaymentByTarget = registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember;
    const showNextButton =
      currentStep == firstStepIdx ||
      (currentStep == secondStepIdx && isPendingPaymentByTarget) ||
      (registrationRow &&
        registrationRow.regisStatusId !== RegistrationStatuses.InProgress &&
        registrationRow.regisStatusId !==
        RegistrationStatuses.PendingRegistration &&
        (this.state.isExecutePaymentFlow || this.state.isFinishedPaymentFlow) &&
        regisExists);
    return (
      <Modal
        show={this.props.showModal}
        onHide={this.handleClose}
        size="xl"
        centered
        animation={true}
        backdrop="static"
        onShow={this.onShow}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="row">
              <div className="col-xs-12 col-sm-12">
                <h5 className="modal-title mt-0">
                  Registration
                  {`${selectedOpenRegRow &&
                    ` for "${selectedOpenRegRow.title}"
                `} ${selectedOpenRegRow &&
                      !_.isEmpty(selectedOpenRegRow.regisStatus)
                      ? "(" + (selectedOpenRegRow.regisStatus || "") + ")"
                      : ""
                    }`}
                </h5>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        {this.state.initialValues && (
          <Modal.Body className="modal-body">
            <>
              <Formik
                enableReinitialize
                initialValues={this.state.initialValues}
                validationSchema={
                  this.state.pauseRegistration
                    ? null
                    : this.state.validationSchema
                }
                onSubmit={this.onSubmit}
              //validate={this.validate}
              //validate={(values) => {
              // Validate the form using the Yup schema
              // try {
              //   this.state.validationSchema.validateSync(values, {
              //     abortEarly: false,
              //   });
              // } catch (error) {
              //   // Set the errors object using the information from the Yup error
              //   const errors = {};
              //   error.inner.forEach((err) => {
              //     errors[err.path] = err.message;
              //   });
              //   return {};
              // }
              //return {};
              //}}
              >
                {({
                  errors,
                  values,
                  touched,
                  setValues,
                  isValid,
                  handleSubmit,
                  setErrors,
                }) => {
                  this.formikValues = values;

                  // Use useEffect to handle form value changes and update payment steps
                  useEffect(() => {
                    const { prevValues } = this.state;

                    if (JSON.stringify(prevValues) !== JSON.stringify(values)) {
                      // Calculate fee immediately when values change
                      const calculatedFee = this.calculateQuestionsFee(values);
                      const anyFeeQuestionAnswered = this.checkAnyFeeQuestionAnswered(values);

                      this.setState({
                        prevValues: values,
                        questionsFee: calculatedFee,
                        anyFeeQuestions: anyFeeQuestionAnswered
                      }, () => {
                        // Update payment step visibility after state updates
                        this.updatePaymentStepVisibility(anyFeeQuestionAnswered);
                      });
                    }
                  }, [values]);

                  return (
                    <>
                      <Form>
                        <React.Fragment>
                          {/* Step {this.state.currentStep} */}
                          <div className="box">
                            <div className="steps">
                              <ul className="nav">
                                {this.state.steps.map((step, i) => {
                                  return (
                                    <li
                                      key={i}
                                      className={`${this.state.activeStep.key === step.key
                                        ? "active"
                                        : ""
                                        } ${step.isDone ? "done" : ""}`}
                                    >
                                      <div className="liChildDiv">
                                        <span className="stepNumber">
                                          Step {i + 1}
                                        </span>
                                        <br />
                                        <span className="stepDetail">
                                          {step.label}
                                        </span>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>

                            {/* // Render the form steps and pass in the required props */}
                            <StepOne currentStep={currentStep} steps={steps} />

                            {/* Banner for admin-registered payment completion - Only show on Step 1 */}
                            {registrationRow &&
                             registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember &&
                             currentStep === steps.findIndex((i) => i.key == RegisWizardSteps.FirstStep) && (
                              <div className="alert alert-info d-flex align-items-center mb-3">
                                <i className="fa fa-info-circle mr-2" style={{ fontSize: '1.5rem' }}></i>
                                <div>
                                  <strong>Registration submitted by Administrator</strong>
                                  <p className="mb-0 small">Review the details below and proceed to payment to confirm your registration.</p>
                                </div>
                              </div>
                            )}

                            {/* Admin Member Selection - Only show on Steps 1 and 2 when registering for others */}
                            {isRegisteringForOthers && (currentStep === firstStepIdx || currentStep === secondStepIdx) && (
                              <div className="row mb-4">
                                <div className="col-md-12">
                                  <div className="card border-primary">
                                    <div className="card-header bg-primary text-white">
                                      <h6 className="mb-0">
                                        <i className="fa fa-users mr-2"></i>
                                        Admin Registration
                                      </h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="form-group">
                                        <label className="form-label font-weight-bold">
                                          Register for another member (optional)
                                          <small className="d-block text-muted mt-1">
                                            Leave empty to register for yourself
                                          </small>
                                        </label>
                                        <Autocomplete
                                          options={this.state.memberOptions || []}
                                          // The server has already done the searching, so take its
                                          // results as they are. Without this, MUI re-filters them
                                          // against getOptionLabel below -- a substring test on the
                                          // visible text -- and silently drops anything that matched
                                          // on a field the label does not show: member number,
                                          // email, nickname, previous last name. Every other member
                                          // picker in the app already does this (the F&E approver
                                          // pickers, Add Template, PAC Tracker); this one was the
                                          // exception, which is why those searches came back empty.
                                          filterOptions={(options) => options}
                                          loading={this.state.memberSearchInFlight}
                                          loadingText="Searching members..."
                                          // Says what was searched and what is excluded. Terminated
                                          // members are deliberately absent from the directory, which
                                          // otherwise looks identical to a broken search.
                                          noOptionsText={
                                            (this.state.searchTerm || "").length < 2
                                              ? "Type at least two characters"
                                              : (this.state.searchTerm || "").includes(" ")
                                                ? "No active members match that first and last name."
                                                : "No active members with that last name. If you typed a first name, add the last name too."
                                          }
                                          getOptionLabel={(option) =>
                                            option
                                              ? `${option.name || `${option.firstName || ""} ${option.lastName || ""}`.trim()}${option.memberNumber ? ` - ${option.memberNumber}` : ""} - ${option.region}/${option.facility}`
                                              : ""
                                          }
                                          value={(this.state.memberOptions && this.state.memberOptions.find(m => m.id === this.state.selectedTargetMemberId)) || null}
                                          onChange={this.handleTargetMemberSelection}
                                          onInputChange={(e, value) => this.memberSearchHandler(value)}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label="Search and select member"
                                              variant="outlined"
                                              placeholder="Last name, or first and last name"
                                              // The search matches a single word against the LAST
                                              // name only, and two words as first-then-last. That
                                              // is not guessable, and typing a first name returns
                                              // an empty box that reads as a broken search -- which
                                              // is how it was reported. Until the predicate itself
                                              // is widened, say the rule rather than leave people
                                              // to infer it.
                                              helperText="One word searches the last name. For a first name, type both: e.g. John Doe"
                                              fullWidth
                                            />
                                          )}
                                        />
                                        {this.state.selectedTargetMemberName && (
                                          <div className="mt-2">
                                            {this.state.targetCheckInFlight ? (
                                              <div className="alert alert-secondary mb-0">
                                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                                Checking <strong>{this.state.selectedTargetMemberName}</strong>'s
                                                existing registrations for this class...
                                              </div>
                                            ) : this.state.targetRegistrationBlocked ? (
                                              // Settled registration: the submit will be refused, so say
                                              // so now rather than after the form has been filled in.
                                              <div className="alert alert-warning mb-0">
                                                <i className="fa fa-exclamation-triangle mr-2"></i>
                                                <strong>{this.state.selectedTargetMemberName}</strong> already has a
                                                registration for this class
                                                {" "}({this.state.targetRegistrationBlocked.statusName}).
                                                <div className="small mt-1">
                                                  Choose a different member. To change their answers, open the
                                                  registration from Review Requests.
                                                </div>
                                              </div>
                                            ) : this.state.targetAdoptedStatusId ? (
                                              // Unfinished registration, and their answers are now on screen.
                                              // Worth saying, because the admin is completing their
                                              // registration rather than creating one.
                                              <div className="alert alert-info mb-0">
                                                <i className="fa fa-info-circle mr-2"></i>
                                                <strong>{this.state.selectedTargetMemberName}</strong> has an unfinished
                                                registration
                                                {" "}({this.state.targetAdoptedStatusName}).
                                                <div className="small mt-1">
                                                  Their existing answers are shown below. Submitting will complete
                                                  this registration rather than create a new one.
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="alert alert-success mb-0">
                                                <i className="fa fa-check-circle mr-2"></i>
                                                <strong>Selected:</strong> {this.state.selectedTargetMemberName}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Step Two has Dynamic Questions */}
                            <StepTwo
                              currentStep={this.state.currentStep}
                              erros={errors}
                              setValues={setValues}
                              values={values}
                              steps={steps}
                              isPendingPaymentByTarget={registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember}
                              isDisabled={(() => {
                                // Special case: PendingPaymentByTargetMember should have read-only questions
                                if (registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember) {
                                  return true; // Questions are disabled (read-only) for payment completion
                                }

                                // Normal edit mode for InProgress and PendingRegistration
                                return (
                                  registrationRow &&
                                  registrationRow.regisStatusId !=
                                  RegistrationStatuses.InProgress &&
                                  registrationRow.regisStatusId !=
                                  RegistrationStatuses.PendingRegistration &&
                                  regisExists
                                );
                              })()}
                            />

                            {/* Show payment deferral badge for admin registrations with fees */}
                            {(() => {
                              const secondStepIndex = steps.findIndex((i) => i.key === RegisWizardSteps.SecondStep);

                              // Calculate fee in real-time based on current form values
                              const calculatedFee = this.calculateQuestionsFee(values);
                              const anyFeeQuestionAnswered = this.checkAnyFeeQuestionAnswered(values);

                              const shouldShowBadge = isRegisteringForOthers &&
                                this.state.selectedTargetMemberId &&
                                this.state.currentStep === secondStepIndex &&
                                (calculatedFee > 0 || anyFeeQuestionAnswered);

                              console.log('PaymentDeferralBadge Debug:', {
                                isRegisteringForOthers,
                                selectedTargetMemberId: this.state.selectedTargetMemberId,
                                currentStep: this.state.currentStep,
                                secondStepIndex,
                                calculatedFee,
                                anyFeeQuestionAnswered,
                                shouldShowBadge
                              });

                              return shouldShowBadge && (
                                <PaymentDeferralBadge
                                  targetMemberName={this.state.selectedTargetMemberName}
                                  questionsFee={calculatedFee}
                                />
                              );
                            })()}

                            {/* Step Three has Payment Screen */}

                            <div ref={this.portalRef} />
                            {/* Show appropriate success component based on registration type */}
                            {isRegisteringForOthers && this.state.selectedTargetMemberId ? (
                              <AdminDeferredPaymentSuccess
                                currentStep={currentStep}
                                steps={steps}
                                targetMemberName={this.state.selectedTargetMemberName}
                                questionsFee={this.state.questionsFee || 0}
                              />
                            ) : (
                              <SucessfulPayment
                                currentStep={currentStep}
                                isFinishedPaymentFlow={
                                  this.state.isFinishedPaymentFlow
                                }
                                steps={steps}
                              />
                            )}
                          </div>
                        </React.Fragment>
                        <div className="card-footer text-center border-top-0">
                          {registrationRow &&
                            this.props.regTableType ==
                            RegistrationTableTypes.MyRegistrations &&
                            (registrationRow.regisStatusId ==
                              RegistrationStatuses.InProgress ||
                              registrationRow.regisStatusId ==
                              RegistrationStatuses.PendingRegistration) && (
                              <button
                                type="button"
                                className="btn btn-primary mr-1 cancelModal bg-danger"
                                onClick={() =>
                                  RegistrationsService.CancelRegistration(
                                    registrationRow.id
                                  )
                                }
                              >
                                Cancel Reg.
                              </button>
                            )}
                          <button
                            type="button"
                            className="btn btn-primary mr-1 cancelModal"
                            onClick={this.handleClose}
                          >
                            Close
                          </button>
                          {(currentStep == firstStepIdx ||
                            currentStep == secondStepIdx) &&
                            ((registrationRow &&
                              (registrationRow.regisStatusId ==
                                RegistrationStatuses.InProgress ||
                                registrationRow.regisStatusId ==
                                RegistrationStatuses.PendingRegistration)) ||
                              !regisExists) && (
                              /* disabled also when the chosen member already holds a settled
                                 registration: the server answers that post with a 409, so
                                 letting it be pressed only produces a toast after the work. */
                              <button
                                type="submit"
                                disabled={!isValid || !!this.state.targetRegistrationBlocked || this.state.targetCheckInFlight}
                                title={this.state.targetRegistrationBlocked
                                  ? "This member already has a registration for this class."
                                  : undefined}
                                className={`btn btn-success mr-1 wizardSubmit ${currentStep == secondStepIdx ? "" : "hidden"
                                  }`}
                              >
                                {this.state.isExecutePaymentFlow ? (
                                  <i
                                    class="fa fa-arrow-circle-right"
                                    aria-hidden="true"
                                  >
                                    Next
                                  </i>
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            )}
                          {thirdStepIdx != -1
                            ? currentStep <= thirdStepIdx && this.previousButton
                            : this.previousButton}

                          {/* //Next Button// */}
                          {showNextButton && this.nextButton}
                        </div>
                      </Form>
                      <CloseRegistrationWizardModal
                        modal={this.state.showConfirmCloseRegModal}
                        confirm={this.confirmCancelRegModal}
                        toggle={this.toggleShowConfirmCloseRegModal}
                        justCloseRegModal={this.justCloseRegModal}
                        regTableType={this.props.regTableType}
                        registrationRow={registrationRow}
                        // Delete, not cancel: the only status this prompt offers the action for
                        // is In Progress, which is an unfinished draft. MN-2086 adds Cancel back
                        // for the statuses where a member actually holds a place.
                        deleteRegistration={
                          RegistrationsService.RemoveRegistration
                        }
                        submitFormData={handleSubmit}
                        isFormValid={isValid}
                        setFormErrors={setErrors}
                        // Computed here because the step index is only meaningful against
                        // this.state.steps, which the prompt does not have. It previously
                        // compared currentStep -- a numeric index -- against
                        // RegisWizardSteps.SecondStep, which is the string "secondStep", so the
                        // test never held and "Save And Close" was never rendered on any step.
                        isOnQuestionsStep={this.state.currentStep === secondStepIdx}
                      />
                    </>
                  );
                }}
              </Formik>

              {/* Show registration type label on Step 3 (Payment) for admins with on-behalf permission */}
              {isRegisteringForOthers &&
               currentStep === thirdStepIdx &&
               this.state.isExecutePaymentFlow && (
                <div className="alert alert-info d-flex align-items-center mb-3">
                  <i className="fa fa-user-circle mr-2" style={{ fontSize: '1.5rem' }}></i>
                  <div>
                    {this.state.selectedTargetMemberId && this.state.selectedTargetMemberName ? (
                      // On-behalf registration (shouldn't reach Step 3, but handle just in case)
                      <><strong>Registering for:</strong> {this.state.selectedTargetMemberName}</>
                    ) : (
                      // Self-registration by admin
                      <><strong>Registration Type:</strong> Self-Registration</>
                    )}
                  </div>
                </div>
              )}

              {this.state.isExecutePaymentFlow && (
                <Portal container={this.portalRef.current}>
                  <StepThree
                    currentStep={this.state.currentStep}
                    nextStep={this._next}
                    steps={steps}
                    closeRegistrationModal={this.props.onClose}
                    occasionId={occasionId}
                    registrationId={registrationId}
                    isFinishedPaymentFlow={this.state.isFinishedPaymentFlow}
                    questionsFee={this.state.questionsFee}
                  />
                </Portal>
              )}
            </>
          </Modal.Body>
        )
        }
      </Modal>
    );
  }
}
export default withRouter(
  connect(
    (state) => ({
      registrationsState: state.registrations,
    }),
    {
      ...registrationsAction,
    }
  )(RegisterMemberModal)
);
